<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-address-card"></i>
    <ng-container *ngIf="data.title">{{ data.title }}</ng-container>
    <ng-container *ngIf="!data.title" i18n>Edit Address</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div [formGroup]="form">
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <input matInput placeholder="Address" i18n-placeholder type="text" formControlName="address" required />
          <mat-error i18n *ngIf="form.get('address').touched && form.get('address').hasError('allSpaces')">
            Address cannot be spaces alone.
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <input matInput placeholder="City" i18n-placeholder type="text" formControlName="city" required />
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <input
            matInput
            placeholder="State / Province / Region"
            i18n-placeholder
            type="text"
            formControlName="state"
            required
          />
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <input
            matInput
            placeholder="Postal Code"
            i18n-placeholder
            type="text"
            formControlName="postal_code"
            required
          />
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <app-country-select [codeCtrl]="form.get('country_code')" [nameCtrl]="form.get('country')"></app-country-select>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
